export default __webpack_public_path__ + "static/media/spiral_2.73785a9c.svg";